import { render } from "./app.svg?vue&type=template&id=8009d130"
const script = {}
script.render = render

export default script